/* eslint-disable no-empty-function */
import { CollectionIcon } from "@heroicons/react/outline";
import CoursesListItem from "./CoursesListItem";
import PropTypes from "prop-types";

const CoursesList = ({
	courses,
	selectable,
	selected,
	setNewCoursesToRegister,
	showRemoveButton,
	title
}) => (
	<div className="class-list">
		<div className="meta-item d-flex align-items-center mb-3">
			<CollectionIcon className="text-blue me-2" style={{ width: "20px" }} />

			<span className="fs-14 text-uppercase fw-bold text-neutral3">
				{title}
			</span>
		</div>

		{courses.length > 0 && courses.map((course) => (
			<CoursesListItem
				checked={selected.filter(({ id }) => id === course.id).length > 0}
				course={course}
				key={course.id}
				selectable={selectable}
				setNewCoursesToRegister={setNewCoursesToRegister}
				showRemoveButton={showRemoveButton}
			/>
		))}
	</div>
);

CoursesList.propTypes = {
	courses: PropTypes.arrayOf(PropTypes.shape({
		description: PropTypes.string,
		end: PropTypes.instanceOf(Date),
		facilitator: PropTypes.string,
		id: PropTypes.number,
		series: PropTypes.string,
		start: PropTypes.instanceOf(Date),
		title: PropTypes.string
	})).isRequired,
	selectable: PropTypes.bool,
	selected: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number
	})),
	setNewCoursesToRegister: PropTypes.func,
	showRemoveButton: PropTypes.bool,
	title: PropTypes.string
};

CoursesList.defaultProps = {
	selectable: true,
	selected: [],
	setNewCoursesToRegister: () => {},
	showRemoveButton: true,
	title: "List of Classes"
};

export default CoursesList;
